import { StyledHtmlText } from '@framework/engine/inputs/rich-text/style/StyledHtmlText.tsx';
import { isElement } from '@framework/engine/inputs/rich-text-advanced/render/renderRichTextAdvancedNodes.tsx';
import { Typography } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';

const { Title, Paragraph } = Typography;

import parse, {
  attributesToProps,
  type DOMNode,
  domToReact,
  type HTMLReactParserOptions,
} from 'html-react-parser';

const CoverParagraphTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading2}px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin-bottom: 0.3em;
    b,
    strong {
      font-weight: 700;
    }
  }
`;

export interface IParagraphTitleProps {
  title: string | null | undefined;
}

export function ParagraphTitle(props: IParagraphTitleProps) {
  const { title } = props;

  const renderedTitle = useMemo(() => {
    const options: HTMLReactParserOptions = {
      replace: (domNode: DOMNode) => {
        if (isElement(domNode) && domNode.tagName === 'p') {
          const props = attributesToProps(domNode.attribs);
          return (
            <span {...props} className="paragraph-title">
              {domToReact(domNode.children, options)}
            </span>
          );
        }
      },
    };

    return parse(title ?? '', options);
  }, [title]);

  if (!title) return null;

  return (
    <CoverParagraphTitle level={2}>
      <StyledHtmlText>{renderedTitle}</StyledHtmlText>
    </CoverParagraphTitle>
  );
}
